import React from "react";

const EVENT_TYPES = [
  { value: "birthday", label: "Birthday", tone: "success", dot: "🟢" },
  { value: "wedding", label: "Wedding", tone: "success", dot: "🟢" },
  { value: "engagement", label: "Engagement", tone: "success", dot: "🟢" },
  { value: "anniversary", label: "Anniversary", tone: "success", dot: "🟢" },

  { value: "conference", label: "Conference", tone: "info", dot: "🔵" },
  { value: "seminar", label: "Seminar", tone: "info", dot: "🔵" },
  { value: "meeting", label: "Meeting", tone: "info", dot: "🔵" },

  { value: "party", label: "Party", tone: "danger", dot: "🔴" },
  { value: "concert", label: "Concert", tone: "danger", dot: "🔴" },

  { value: "festival", label: "Festival", tone: "warning", dot: "🟡" },
  { value: "other", label: "Other", tone: "default", dot: "⚪" },
];

const TONE_STYLES = {
  success: { bg: "#dcfce7", text: "#166534", border: "#86efac" }, // green
  danger: { bg: "#fee2e2", text: "#7f1d1d", border: "#fecaca" }, // red
  warning: { bg: "#fef3c7", text: "#7a5200", border: "#fde68a" }, // amber
  info: { bg: "#dbeafe", text: "#1e40af", border: "#bfdbfe" }, // blue
  default: { bg: "#eef2f7", text: "#1f2937", border: "#e5e7eb" }, // grey
};

function EventsSelecter({ handleChange, eventDetails }) {
  if (!eventDetails) return;
  const TypeBadge = ({ tone, label }) => {
    const t = TONE_STYLES[tone] || TONE_STYLES.default;
    return (
      <span
        style={{
          display: "inline-block",
          padding: "4px 8px",
          borderRadius: 30,
          background: t.bg,
          color: t.text,
          border: `1px solid ${t.border}`,
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        {label}
      </span>
    );
  };

  console.log(eventDetails, "eventDetails");

  return (
    <>
      <select
        id="event_type"
        name="event_type"
        className="form-select"
        onChange={handleChange}
        value={eventDetails?.event_type ?? "other"}
      >
        <option value="default" disabled>
          Default
        </option>
        {EVENT_TYPES.map((t) => (
          <option key={t.value} value={t.value}>
            {t.dot} {t.label}
          </option>
        ))}
      </select>
      {/* live colour preview chip */}
      {eventDetails.event_type && (
        <div className="mt-4">
          {(() => {
            const cur = EVENT_TYPES.find(
              (x) => x.value === eventDetails.event_type
            );
            return (
              <TypeBadge
                tone={cur?.tone}
                label={cur?.label || eventDetails.event_type}
              />
            );
          })()}
        </div>
      )}
    </>
  );
}

export default EventsSelecter;
